const initialState = {
  triggeredAnalytics: {
    checkbox: false,
    togglePassword: false,
    submit: false,
  },
  analyticsPermitted: false,
  errorMessage: null,
  registered: false,
  registeredEmail: '',
  conditions: false,
  toggle: false,
  name: {
    text: '',
    status: 'default',
    error: '',
    label: 'name',
    type: 'text',
    clicked: false,
    labelKey: 'signup.input_name_title',
  },
  email: {
    text: '',
    status: 'default',
    type: 'email',
    error: '',
    label: 'email',
    clicked: false,
    labelKey: 'signup.input_email_title',
  },
  password: {
    text: '',
    status: 'default',
    error: '',
    type: 'password',
    label: 'password',
    clicked: false,
    labelKey: 'signup.input_password_title',
  },
  repeatPassword: {
    text: '',
    status: 'default',
    error: '',
    type: 'password',
    label: 'repeatPassword',
    clicked: false,
    labelKey: 'signup.input_password_repeat_title',
  },
};
export default initialState;
